import { useLayoutEffect, useState } from 'react';
import { bindVideoReadyListeners } from '@/common/functions/videoElement';

const useVideoReady = (videoRef, videoSrc, remountKey = '') => {
	const [isReady, setIsReady] = useState(false);

	useLayoutEffect(() => {
		setIsReady(false);
	}, [videoSrc, remountKey]);

	useLayoutEffect(() => {
		if (!videoSrc) {
			return undefined;
		}

		const video = videoRef.current;

		if (!video) {
			return undefined;
		}

		return bindVideoReadyListeners(
			video,
			() => setIsReady(true),
			() => setIsReady(false),
		);
	}, [videoRef, videoSrc, remountKey]);

	return isReady;
};

export default useVideoReady;
